import { render } from "./CalendarController.vue?vue&type=template&id=aa85c686&ts=true"
import script from "./CalendarController.vue?vue&type=script&lang=ts"
export * from "./CalendarController.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__